<template>
  <v-sheet color="white" elevation="5" rounded class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3">
    <div class="profile-content">
        <h1>My Membership Information</h1>
        <v-row class="ma-0">  
          <v-card class="user-profile-card">
            <h3 class="mb-3">Membership Info</h3>  
            <v-row class="ma-0">
              <v-col>
                <table class="user-profile-table" v-if="userInfo && !userInfo.hasNeverBeenMember">
                  <tr>
                    <td><b>Member ID</b></td>
                    <td>{{ userInfo.memberId }}</td>
                  </tr>
                  <tr>
                    <td><b>Full Years of Active Membership</b></td>
                    <td>{{ userInfo.fullYearsOfActiveMembership }}</td>
                  </tr>
                  <tr>
                    <td><b>Membership expiry date</b></td>
                    <td>
                      <localized-date v-if="userInfo.membershipExpiryDate" :date="userInfo.membershipExpiryDate" />
                      <span v-else>-</span>
                    </td>
                  </tr>
                  <tr v-if="!!userInfo.aussieTimesExpiryDate">
                    <td><b>Aussie Times print subscription </b></td>
                    <td>
                      <localized-date :date="userInfo.aussieTimesExpiryDate" />
                      <span v-if="!!userInfo.aussieTimesSubscriptionType"> ({{userInfo.aussieTimesSubscriptionType}} postage)</span>
                    </td>
                  </tr>
                </table>   
              </v-col>
              <v-col>
                <v-btn v-if="userInfo && userInfo.hasNeverBeenMember"
                  dark
                  large
                  color="primary"
                  @click="gainMembership"
                >Gain Membership</v-btn>
                <v-btn v-if="userInfo && !userInfo.hasNeverBeenMember && juniorShouldRegister"
                  dark
                  large
                  color="primary"
                  @click="registerMembership"
                >Register Membership</v-btn>
                <v-btn v-if="userInfo && canRenew && shouldRenew"
                  dark
                  large
                  color="primary"
                  @click="renewMembership"
                >Renew membership</v-btn>
                <v-btn v-if="userInfo && userInfo.isActiveMember && userInfo.shouldRenewAussieTimes"
                  dark
                  large
                  color="primary"
                  @click="renewAussieTimes"
                  >Renew Aussie Times</v-btn>
              </v-col>      
            </v-row>  
          </v-card>
        </v-row>
        <v-row>
          <v-col>
            <v-card v-if="userInfo && userInfo.isActiveMember">
              <v-card-title>
                <v-spacer/>
                  <v-btn 
                    large
                    color="primary"
                    @click="print"
                    >Print Card</v-btn>
                  <v-btn 
                    class="ml-5"
                    large
                    disabled
                    color="primary"
                     click="requestCard"
                    >Order Card</v-btn>
              </v-card-title>
              <v-card-text>
                <report-viewer    
                  reportName="Asca.Api.Reports.rpt1220_Person_Membership_Card.rdlx"
                  :dataUrl="`/reports/membershipcard/${userInfo.personId}`"
                  ref="reportViewer"
                  :printOnly="true"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>    
    </div>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import ReportViewer from '@/components/Admin/Reports/ReportViewer.vue';
import { getAscaToday } from "@/helpers/date-utils";
import { UserInfo } from "@/types/User";
import { MemberType } from "@/types/Member";

export default Vue.extend({
  name: "MyMembershipInfo",
  components: {
    ReportViewer
  },
  data: function() {
    return {
      showLoader: false,
      errorMessage: "",
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    canRenew(): boolean {
      return !this.userInfo.hasNeverBeenMember && this.userInfo.memberType != MemberType.Junior;
    },
    shouldRenew(): boolean {
      if (!this.$store.state.userInfo.membershipExpiryDate) return false;
      return getAscaToday().until(this.$store.state.userInfo.membershipExpiryDate).days <= 30;
    },
    juniorShouldRegister(): boolean {
      return this.userInfo.memberType == MemberType.Junior
        && (!!this.userInfo?.juniorHasToRegister
          || (!!this.$store.state.userInfo.membershipExpiryDate
            && getAscaToday().until(this.$store.state.userInfo.membershipExpiryDate).days <= 30));
    },
    reportViewer(): any {
      return this.$refs.reportViewer;
    }
  },
  methods: {
    async print() {
      this.reportViewer.printReport();
    },
    requestCard() {

    },
    gainMembership() {
      this.$router.push('/gain-membership')
    },
    registerMembership() {
      this.$router.push('/registration/member')
    },
    renewMembership() {
      this.$router.push('/renew/member')
    },
    renewAussieTimes() {
      this.$router.push('/renew/member/aussietimes')
    },
  },
});
</script>
